package com.iregained.eventapp.components.sections.admin_dashboard.sections

import androidx.compose.runtime.Composable
import com.iregained.eventapp.components.sections.admin_dashboard.styles.KanbanColumnStyle
import com.iregained.eventapp.components.sections.admin_dashboard.styles.PatientCardStyle
import com.iregained.eventapp.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun LiveQueueSection() {
    val palette = ColorMode.current.toSitePalette()

    Column(modifier = Modifier.fillMaxWidth()) {
        SpanText(
            text = "Live Patient Queue",
            modifier = Modifier.fontSize(24.px).fontWeight(FontWeight.Bold).margin(bottom = 24.px)
        )

        // Fully responsive grid: 1 column on mobile, 3 columns on desktop
        SimpleGrid(
            numColumns = numColumns(1, lg = 3), modifier = Modifier.fillMaxWidth().gap(24.px)
        ) {
            // Column 1: Expected Arrivals
            QueueColumn(title = "Expected Arrivals", count = 2) {
                PatientCard("Justin Mason", "09:00 AM", "BOOKED", palette.custom.neutralDisabled)
                PatientCard("Sarah Connor", "09:30 AM", "BOOKED", palette.custom.neutralDisabled)
            }

            // Column 2: In Clinic
            QueueColumn(title = "In Progress", count = 1) {
                PatientCard("Michael Scott", "08:30 AM", "PRE_COMPLETE", palette.brand.primarySoft)
            }

            // Column 3: Ready for Exit
            QueueColumn(title = "Pending Exit Survey", count = 1) {
                PatientCard("Pam Beesly", "08:00 AM", "TRIAL_COMPLETE", palette.brand.accentGreen)
            }
        }
    }
}

@Composable
private fun QueueColumn(title: String, count: Int, content: @Composable () -> Unit) {
    val palette = ColorMode.current.toSitePalette()
    Column(
        modifier = KanbanColumnStyle.toModifier().backgroundColor(palette.custom.neutralLight)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().margin(bottom = 16.px), horizontalArrangement = Arrangement.SpaceBetween
        ) {
            SpanText(title, modifier = Modifier.fontWeight(FontWeight.Bold))
            SpanText(count.toString(), modifier = Modifier.fontWeight(FontWeight.Bold).color(palette.custom.darkText))
        }
        content()
    }
}

@Composable
private fun PatientCard(
    name: String, time: String, status: String, statusColor: org.jetbrains.compose.web.css.CSSColorValue
) {
    val palette = ColorMode.current.toSitePalette()
    Column(
        modifier = PatientCardStyle.toModifier().backgroundColor(palette.custom.cardBackground)
            .borderLeft(4.px, LineStyle.Solid, statusColor)
    ) {
        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
            SpanText(name, modifier = Modifier.fontWeight(FontWeight.Bold).fontSize(16.px))
            SpanText(time, modifier = Modifier.fontWeight(FontWeight.Medium).fontSize(14.px))
        }
        SpanText(
            status,
            modifier = Modifier.fontSize(12.px).color(statusColor).fontWeight(FontWeight.Bold).margin(top = 8.px)
        )
    }
}